import Breadcrumbs from './Breadcrumbs.component';

export default Breadcrumbs;
